import React from 'react';
import { useTranslation } from 'react-i18next';
import Checkbox from 'src/common/refactoredComponents/checkbox/Checkbox';
import CustomLabel from 'src/pages/reportUsage/common/customLabel/CustomLabel';
import { BROWN_FONT_COLOR, SEMANTIC_TEXT_SMALL_PX } from 'src/styles/fonts/MCFontConstants';
import { sizes } from 'src/styles/Media.styled';
import { isIpad } from 'src/utils/util';

const QuantityCheckboxes = ({
    item,
    index,
    lotItem,
    lotItemIdx,
    lotSerialValueEntered,
    showTopLabel,
    isChildItem,
    padding,
}) => {
    const { t } = useTranslation();
    return (
        <>
            <span
                style={{
                    padding: showTopLabel
                        ? padding  ? padding : '0 0 0 10px'
                        : window.innerWidth <= sizes.mobileDevice
                        ? '1px 0 0 10px'
                        : '1px 0 0 5px',
                }}
            >
                {showTopLabel && (
                    <CustomLabel
                        fSize={'12px!important'}
                        color="#140F4B"
                        opacity="70%"
                        label={t(
                            'reportUsage.record.itemsList.QuantityInputBoxes.used'
                        )}
                        textAlign={'center'}
                    />
                )}
                <Checkbox
                    checked={lotItem.used}
                    id="reportUsage-record-itemsList-QuantityCheckboxes-lotItemUsed"
                    data-testid={`other-checkbox-${index}-${lotItemIdx}`}
                    onCheckboxSelectionChange={(e) =>
                        lotSerialValueEntered(
                            e,
                            item,
                            index,
                            lotItem,
                            lotItemIdx,
                            'usedChecked'
                        )
                    }
                    margin={'0px 5px 0px 0px'}
                    labelStyleObj={{
                        fontSize: SEMANTIC_TEXT_SMALL_PX,
                        color: BROWN_FONT_COLOR,
                    }}
                    background={'none'}
                    checkboxBorder={'1.5px solid #555555'}
                    alignItemDirection={'center'}
                    hoverEffect={'false'}
                    disableFocusEffect={'true'}
                />
            </span>
            <span
                style={{
                    padding: showTopLabel
                         ? padding  ? padding : '0 0 0 10px'
                        : window.innerWidth <= sizes.mobileDevice
                        ? '1px 7px 0 14px'
                        : '1px 7px 0 17px',
                }}
            >
                {!item.isBundleItem && !isChildItem && (
                    <>
                        {showTopLabel && (
                            <CustomLabel
                                fSize={'12px!important'}
                                color="#140F4B"
                                opacity="70%"
                                label={t('reportUsage.itemList.other')}
                                textAlign={'center'}
                            />
                        )}
                        <Checkbox
                            checked={lotItem.other}
                            id="reportUsage-record-itemsList-QuantityCheckboxes-lotItemOther"
                            data-testid={`other-checkbox-${index}-${lotItemIdx}`}
                            onCheckboxSelectionChange={(e) =>
                                lotSerialValueEntered(
                                e,
                                item,
                                index,
                                lotItem,
                                lotItemIdx,
                                'otherChecked'
                            )}
                            margin={'0px 5px 0px 0px'}
                            labelStyleObj={{
                                fontSize: SEMANTIC_TEXT_SMALL_PX,
                                color: BROWN_FONT_COLOR,
                            }}
                            background={'none'}
                            checkboxBorder={'1.5px solid #555555'}
                            alignItemDirection={'center'}
                            hoverEffect={'false'}
                            disableFocusEffect={'true'}
                        />
                    </>
                )}
            </span>
        </>
    );
};

export default QuantityCheckboxes;
